// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"InviteManager_tableRow_2I8zP","mtS":"InviteManager_mtS_25z_D"};